export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'
export const SET_ERROR = 'setError'
export const SET_ANALYSIS = 'setAnalysis'
export const SET_INFO = "setInfo"
export const SET_LOADING_STATUS = "setLoadingStatus"